module.exports = __webpack_public_path__ + "img/xiazai2.26cfc43d.png";